// UI-Scale-Setting (Slice 3): skaliert Toolbars, Bottom-Strip, Inspektor-Pills.
// Canvas-World ist davon NICHT betroffen — die hat einen eigenen Pan/Zoom.
// Persistiert in localStorage, beim App-Start sofort auf html-Element angewendet.

export const UI_SCALE_VALUES = ["1", "1.1", "1.25"] as const;
export type UiScale = (typeof UI_SCALE_VALUES)[number];

const STORAGE_KEY = "ms-wb:ui-scale";

export function loadUiScale(): UiScale {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw && (UI_SCALE_VALUES as readonly string[]).includes(raw)) {
      return raw as UiScale;
    }
  } catch {
    /* localStorage disabled — Fallback Default. */
  }
  return "1";
}

export function saveUiScale(value: UiScale): void {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* ignore — Setting bleibt fuer die Session aktiv, persistiert nur nicht. */
  }
}

export function applyUiScale(value: UiScale): void {
  document.documentElement.style.setProperty("--ui-scale", value);
}

// Side-effect beim Import: vor dem ersten Render anwenden, kein Flicker.
applyUiScale(loadUiScale());
